<ng-container [ngSwitch]="mode">
  <ng-container
    *ngSwitchCase="LabelMode.DEFAULT"
    [ngTemplateOutlet]="default"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.INLINE"
    [ngTemplateOutlet]="inline"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.NO_LABEL"
    [ngTemplateOutlet]="input"
  ></ng-container>
</ng-container>

<ng-template #input>
  <input
    type="checkbox"
    class="form-check-input w-45px h-30px"
    [id]="name"
    [formControl]="form"
    [name]="name"
  />
</ng-template>

<ng-template #inline>
  <div class="form-check form-switch d-flex">
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <label
      class="col-form-label fw-bold fs-6 d-flex align-items-center ps-3 py-0"
      [ngClass]="required ? 'required' : ''"
      [for]="name"
      >{{ label | translate
      }}<span *ngIf="isStar" class="required">*</span></label
    >
  </div>
</ng-template>

<ng-template #default>
  <div class="cform-check form-switch d-flex form-check-sm">
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <label
      class="col-form-label fw-bold fs-6 d-flex align-items-center ps-3 py-0"
      [ngClass]="required ? 'required' : ''"
      [for]="name"
      >{{ label | translate
      }}<span *ngIf="isStar" class="required">*</span></label
    >
  </div>
</ng-template>
